export enum CreateClientFormStep {
  FORM = 0,
  VERIFICATION = 1,
}
